import { createFileRoute, redirect } from "@tanstack/react-router";

/**
 * Join-request emails already delivered link here, and a delivered email cannot be corrected. The
 * requests are listed under Members, so this goes there. The UK spelling stays: the path is already
 * delivered outside the repository, the one exception to the American-English naming rule.
 */
export const Route = createFileRoute("/_authenticated/_workspace/settings/organisation")({
  beforeLoad: () => {
    throw redirect({ to: "/settings/members", replace: true });
  },
});
